import React from 'react';
import { Step, StepLabel, Stepper } from '@material-ui/core/';
import { useSelector } from 'react-redux';

//stepper component, with default state for steps and active step
export default function CustomizedSteppers(props) {
	const state = useSelector((state) => state.stepper);
	const activeStep = state.activeStep;
	const steps = props.steps;
	return (
		<Stepper alternativeLabel activeStep={activeStep}>
			{steps.map((label) => (
				<Step key={label}>
					<StepLabel>{label}</StepLabel>
				</Step>
			))}
		</Stepper>
	);
}
